import React from 'react';
import { Check } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const ProductCard = ({ product }) => {
  return (
    <Card className="group border-2 border-gray-200 hover:border-black transition-all duration-300 overflow-hidden bg-white hover:shadow-lg">
      {/* Product Image */}
      {product.image && (
        <div className="relative h-56 overflow-hidden bg-gray-100">
          <img 
            src={product.image} 
            alt={product.name}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-4 left-4">
            <Badge variant="outline" className="bg-white/90 backdrop-blur-sm border-gray-300 text-gray-700">
              {product.category.toUpperCase()}
            </Badge>
          </div>
        </div>
      )}

      {/* Product Header */}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 border-b border-gray-200">
        {!product.image && (
          <Badge variant="outline" className="mb-3 border-gray-300 text-gray-700">
            {product.category.toUpperCase()}
          </Badge>
        )}
        <h3 className="text-2xl font-bold text-black mb-2">{product.name}</h3>
        <p className="text-gray-700 font-medium">{product.shortDesc}</p>
      </div>

      {/* Product Content */}
      <div className="p-6">
        <p className="text-gray-600 mb-6 leading-relaxed">
          {product.description}
        </p>

        {/* Features List */}
        <div className="space-y-3">
          <h4 className="font-semibold text-black text-sm uppercase tracking-wide mb-3">Key Features</h4>
          {product.features.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="flex-shrink-0 w-5 h-5 bg-black rounded-full flex items-center justify-center mt-0.5">
                <Check className="text-white" size={12} />
              </div>
              <span className="text-gray-700 text-sm">{feature}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Hover Effect Footer */}
      <div className="h-1 bg-gradient-to-r from-gray-200 to-gray-300 group-hover:from-black group-hover:to-gray-800 transition-all duration-300"></div>
    </Card>
  );
};

export default ProductCard;
